import React, { useState } from 'react'
import { Wrapper } from '../style'
import { Button, ConfigProvider, Dropdown, Menu, Pagination, Table, Tooltip } from 'antd';
import { fakeProImage } from '../../../../config/fakeData';

function EmailAlerts({loading, list}) {

  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);




const dataSource = [
  {
    key: "1",
    id: 1,
    productImage: "assets/media/dummy.jpg",
    productName: "Paper Jewelry Earring Storage Box Red 22....",
    sku: "AS33ASKK30",
    asin: "B0XMXUPXX",
    category: "Jewelry",
    alert_name: `Almost out of stock`,
    type: "Default",
  },
  
];

const columns = [
  {
    title: "#",
    dataIndex: "id",
    width: 50,
  },
  {
    title: "Product Details",
    dataIndex: "productName",
    render: (_, record) => (
      <div className="d-flex align-items-center bdr-left-tbl bg-gray-200 rounded-4 p-3 py-2">
                <div className="symbol symbol-65px overflow-hidden me-3">
                  <img src={record?.item_image || fakeProImage} alt />
                </div>
                <div className="d-flex flex-column">
                  <a href className="text-gray-800 fs-6 text-hover-danger mb-1 fw-bolder text-one min-w-200px">{record?.productName || ''}</a>
                  <div className="fs-7 mt-1"><span><b>SKU:</b> {record?.sku}</span> / <span><b>ASIN:</b> {record?.asin}</span></div>
                  <div className="fs-7 mt-1"><span><b>{record?.currency} {record?.item_price}</b> </span></div>
                </div>
              </div>
    ),
  },
  
  {
    title: "Category",
    dataIndex: "category",
  },
  {
    title: "Alert Name",
    dataIndex: "alert_name",
  },
 
  {
    title: "Type",
    dataIndex: "type",
  },
   {
    title: "Action",
    key: "action",
    render: (_, row) => (
      <Dropdown overlay={menu(row)} trigger={["click"]}>
        <Button type="link" className="" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true" ><i className="ki-solid ki-dots-vertical fs-1 text-gray-800 "></i></Button>
      </Dropdown>
    ),
  },
];



const menu = (row) => (
  <Menu className=" min-w-200px p-3">
    <Menu.Item key="1" className="d-flex align-items-center mb-2" ><i className="ki-outline ki-pencil fs-3 me-2"></i>Edit Alert</Menu.Item>
    <Menu.Item key="2" className="d-flex align-items-center" ><i className="ki-outline ki-trash fs-3 me-2"></i>Delete Alert</Menu.Item>
  </Menu>
);


const theme = {
  token: {
    itemActiveBg: '#ffffff',
    itemActiveBgDisabled: 'rgba(0, 0, 0, 0.15)',
    itemActiveColorDisabled: 'rgba(0, 0, 0, 0.25)',
    itemBg: '#ffffff',
    itemInputBg: '#ffffff',
    itemLinkBg: '#ffffff',
    itemSize: 32,
    itemSizeSM: 24,
    miniOptionsSizeChangerTop: 0,
    colorBgContainer: '#ffffff',
    colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',
    colorBgTextActive: 'rgb(255, 255, 255)',
    colorBgTextHover: 'rgb(255, 255, 255)',
    colorBorder: '#d9d9d9',
    colorPrimary: '#f45b68',
    colorPrimaryBorder: '#f45b68',
    colorPrimaryHover: '#f45b68',
    colorText: 'rgba(0, 0, 0, 0.88)',
    colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
    colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
   
  },
};

  return (
    <Wrapper>
      {/*begin::Row*/}
      <div className="row gy-5 g-xl-5">
        {/*begin::Col*/}
        <div className="col-xxl-12">
          {/*begin::Tables Widget 9*/}
          <div className="card card-xxl-stretch mb-5 mb-xl-8">
            {/*begin::Header*/}
            <div className="card-header border-bottom-dashed">
              <h3 className="card-title fw-bolder">Alerts List</h3>
              <div className="card-toolbar">
            
              </div>
            </div>
            {/*end::Header*/}
            {/*begin::Body*/}
            <div className="card-body py-2">
               {/*begin::Table container*/}
               <div className="table-responsive">
                  {/*begin::Table*/}
                  <Table 
                  // className=" cus-table"
                    scroll={{ x: "max-content" }}
                    columns={columns}
                    loading={loading}
                    dataSource={dataSource}
                    rowKey="key" 
                    pagination={false}
                    components={{
                      table: (props) => (
                        <table className="table table-row-dashed table-row-gray-300 align-middle gs-4 gy-4 fs-7" {...props} />
                      ),
                      header: {
                        wrapper: (props) => <thead {...props} className="" />, // Override and provide an empty class
                        row: (props) => <tr {...props} className="fw-bolder text-dark bg-cus" />,
                        cell: (props) => (
                          <th {...props} className={``} />
                        ),
                      },
                    }}
                  />
                  {/*end::Table*/}
                </div>
                {/*end::Table container*/}
      
            </div>
            {/*begin::Body*/}
          </div>
          {/*end::Tables Widget 9*/}
        </div>
        {/*end::Col*/}
      </div>
      {/*end::Row*/}
      {/*begin::Row*/}
      <div className="row gy-5 g-xl-5">
          {/*begin::Col*/}
          <div className="col-xxl-12">
            {/*begin::Tables Widget 9*/}
            <div className="card card-xxl-stretch mb-5 mb-xl-8">
              {/*begin::Body*/}
              <div className="card-body py-2">
      
               {/* Pagination directly below the table */}
              <ConfigProvider theme={theme}>
              <Pagination
                  className="mt-3"
                  current={page}
                  pageSize={pageSize}
                  total={totalPage}
                  showSizeChanger
                  onChange={(currentPage, newPageSize) => {
                    setPage(currentPage);
                    setPageSize(newPageSize);
                  }}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                />
              </ConfigProvider>
      
              
              </div>
              {/*begin::Body*/}
            </div>
            {/*end::Tables Widget 9*/}
          </div>
          {/*end::Col*/}
        </div>
        {/*end::Row*/}
    </Wrapper>
  )
}

export default EmailAlerts